module.exports = __webpack_public_path__ + "static/media/mock4.6b002231.png";